export default __webpack_public_path__ + "static/media/BlackFrame07.42ac8c39.png";